<template>
  <div class="classlayout">
    <el-main>
      <div class="div">
        <el-button type="primary"
          @click="addClass"
        >
          +&nbsp;新增
        </el-button>
      </div>
      <div class="div2">
        <div class="div2-br">
          <span>学段：</span>
          <div class="btn">
            <el-radio-group
              v-model="stageId"
              @change="changeStage"
            >
              <el-radio-button
                size="small"
                :label="item.id"
                v-for="(item,index ) in stages"
                :key="index"
              >
                {{item.name}}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="div2-br">
          <span>一级：</span>
          <div class="btn">
            <el-radio-group
              v-model="typeId"
              @change="changeOne"
            >
              <el-radio-button
                size="small"
                :label="item.id"
                v-for="(item,index ) in ones"
                :key="index"
              >
                {{item.name}}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <el-table
        :data="columns"
        :height="height"
        v-loading="loading"
        header-row-class-name="header-row-class-name"
        :default-sort="{ prop: 'id', order: 'descending' }"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" sortable label="ID号"></el-table-column>
        <el-table-column prop="ordinal" sortable label="排序值"></el-table-column>
        <el-table-column prop="name" label="栏目名"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.used === true" style="color: #00ff00">
              启用</span
            >
            <span v-if="scope.row.used === false" style="color: #ff0000"
              >禁用</span
            >
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="editClass(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="dealTwo(scope.row.id, false)"
              v-if="scope.row.used == true"
              >禁用</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="dealTwo(scope.row.id, true)"
              v-if="scope.row.used == false"
              >启用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 编辑框 -->
      <edit-dialog
        v-model="classDialogVisible"
        dialogName="column"
        :dialogType="dialogType"
        :stageId="stageId"
        :typeId="typeId"
        :rowData="rowData"
        @success="editSuccess"
      ></edit-dialog>
    </el-main>
  </div>
</template>
<script type="text/babel">
import editDialog from "./edit-dialog";
import commonService from "@/service/commonService";
export default {
  components: {
    editDialog: editDialog,
  },
  name: "commonLevelTwo",
  data() {
    return {
      id: 0,
      rowData: {},
      height: this.SysConstant.winHeight - 280,
      stageId: 0,
      typeId: 0,
      stages: [],
      ones: [],
      columns: [],
      loading: false,
      classDialogVisible: false,
      dialogType: 'add'
    };
  },
  async mounted() {
    // 查询
    this.getStage();
    await this.getOne();
    this.getTwo();
  },
  methods: {
    async getStage() {
      try {
        let data = await commonService.fetchCommonStage();
        data = data.filter(item => {
          return [2, 3, 4].includes(item.id);
        });
        if (data && data.length > 0) {
          this.stageId = data[0].id;
          this.stages = data;
        } else {
          this.stages = [];
        }
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    changeStage() {
      this.getTwo();
    },
    async getOne() {
      try {
        let data = await commonService.common_tag_get('one');
        if (data) {
          this.typeId = data[0].id;
          this.ones = data;
        } else {
          this.ones = [];
        }
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    changeOne() {
      this.getTwo();
    },
    // 获取二级
    async getTwo() {
      console.log('获取二级')
      try {
        let data = await commonService.common_tag_get('two', {
          typeId: this.typeId,
          stageId: this.stageId
        });
        this.columns = data || [];
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    // 新增二级
    async setTwo(params) {
      try {
        await commonService.common_tag_set('two', params);
        this.classDialogVisible = false;
        this.$message.success(this.SysConstant.success);
        this.getTwo();
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    // 启用和禁用
    async dealTwo(id, used) {
      let typeName = used ? '启用': '禁用';
      this.$confirm(`此操作将该${typeName}试卷类型, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(async () => {
        await commonService.common_tag_deal('two', { id, used });
        this.$message.success(this.SysConstant.success);
        this.getTwo();
      });
    },
    addClass() {
      this.rowData = {
        name: '',
        ordinal: ''
      };
      this.dialogType = 'add';
      this.classDialogVisible = true;
    },
    editClass(row) {
      this.rowData = row;
      this.dialogType = 'edit';
      this.classDialogVisible = true;
    },
    editSuccess(data) {
      this.setTwo(data);
    },
  },
};
</script>
<style scoped>
.classlayout .div {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  height: 60px;
  margin-top: -10px;
  margin-bottom: 5px;
}
.classlayout .div {
  margin-top: -10px;
}
.classlayout .div .el-button {
  background-color: #00aaff;
  color: #fff;

  margin: 10px;
  float: left;
}
.classlayout .div2 {
  overflow: hidden;
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  margin: 5px 0;
}
.classlayout .div2 .div2-br{
  overflow: hidden;
}
.classlayout .div2 span {
  margin: 0px 40px;
  float: left;
}
.classlayout .div2 .btn {
  float: left;
  width: 80%;
}
.classlayout .div2 .active {
  background-color: #00aaff;
  color: #fff;
}
</style>
<style type="text/css">
.classlayout .div2 .el-radio-button {
  margin: 10px 10px;
  border: none !important;
  border-radius: 4px !important;
}
.classlayout .el-radio-button__inner {
  border: 1px solid #dcdfe6;
}
</style>




// WEBPACK FOOTER //
// src/pages/layout/common-manage/leveltwo.vue